module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/legalCertificate/legalCertificate-edit/legalCertificate-edit.component.scss
// module id = ./src/app/views/legalCertificate/legalCertificate-edit/legalCertificate-edit.component.scss
// module chunks = main